import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { AppSelectors } from 'app/shared/selectors';
import { StyledFlex, StyledInput } from './StyledComponents';

// the input field needs an onChange handler in order to not be readonly. Since this component needs the key, it really only needs a onKeyDown handler.
const noop = () => {};

const VerificationCodeValidator = ({
    clearErrors,
    codeLength,
    onEnterKeyPress,
    onComplete,
}) => {
    const isMobile = useSelector(state => AppSelectors.makeIsMobile(state));
    const inputRefs = useRef([]);
    const [verificationCode, setVerificationCode] = useState(new Array(codeLength).fill(''));

    useEffect(() => {
        inputRefs.current[0].focus();
    }, []);

    const validateInput = (value) => {
        const numericValue = parseInt(value, 10);
        if ((numericValue >= 0 && numericValue <= 9) || value === '') {
            return true;
        }
        return false;
    };

    const isVerificationCodeComplete = (inputtedCode) => {
        const emptyValues = inputtedCode.filter(num => num === '');
        return emptyValues.length === 0;
    };

    const handleDelete = (index) => {
        const verificationCodeCopy = [...verificationCode];
        verificationCodeCopy[index] = '';
        setVerificationCode(verificationCodeCopy);

        if (index - 1 >= 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handleOnEnterKeyPress = (key) => {
        const isComplete = isVerificationCodeComplete(verificationCode);
        if (isComplete) {
            onComplete(verificationCode.join(''));
            if (key === 'Enter') {
                onEnterKeyPress();
            }
        }
    };

    const handleKeyDown = (e, index) => {
        const { key } = e;
        clearErrors('');

        if (key === 'Backspace') {
            handleDelete(index);
            return;
        }

        if (key === 'Enter') {
            handleOnEnterKeyPress(key);
        }

        if (validateInput(key)) {
            const verificationCodeCopy = [...verificationCode];
            verificationCodeCopy[index] = key;
            const isComplete = isVerificationCodeComplete(verificationCodeCopy);
            const notLastInput = index !== verificationCode.length - 1;

            setVerificationCode(verificationCodeCopy);

            if (isComplete) {
                onComplete(verificationCodeCopy.join(''));
                return;
            }

            if (notLastInput && key !== 'Backspace') {
                inputRefs.current[index + 1].focus();
            }
        }
    };

    return (
        <StyledFlex display="flex">
            {verificationCode.map((value, i) => (
                <StyledInput
                    ref={(el) => { inputRefs.current[i] = el; }}
                    key={`verification-code-${i}`}
                    maxLength="1"
                    value={value}
                    onKeyDown={e => handleKeyDown(e, i)}
                    onChange={noop}
                    type={isMobile ? 'number' : 'text'}
                />
            ))}
        </StyledFlex>
    );
};

export { VerificationCodeValidator };
export default VerificationCodeValidator;
